import { jsx } from "react/jsx-runtime";
import "react";
import { ContentCopy } from "mdi-material-ui";
import { IconButton } from "../IconButton/index.js";
import { useCopyToClipboard } from "../../utils/useCopyToClipboard.js";
function CopyToClipboardButton({ valueToCopy, innerSx, variant = 'secondary', ...props }) {
    const copy = useCopyToClipboard();
    return /*#__PURE__*/ jsx(IconButton, {
        title: "copy-to-clipboard",
        variant: variant,
        onClick: async (e)=>{
            try {
                e.preventDefault();
                e.stopPropagation();
                await copy(valueToCopy);
            } catch (_error) {}
        },
        ...props,
        children: /*#__PURE__*/ jsx(ContentCopy, {
            sx: innerSx
        })
    });
}
export { CopyToClipboardButton };

//# sourceMappingURL=CopyToClipboardButton.js.map